import { DashboardCard } from '@atom/types/dashboard';

import { getCardHeight } from '../dashboardUtilities';

import classes from '../dashboardCard.module.css';

interface Props {
  card: DashboardCard;
}

const CardEmpty = ({ card }: Props) => {
  const isPendingUsers = card.type === 'PENDING_USERS';
  const style = {
    height: getCardHeight(card),
    fontSize: isPendingUsers ? '2.5rem' : 'inherit',
  };
  return (
    <div style={style} className={classes.cardBodyEmpty}>
      {isPendingUsers ? '0' : 'No Results'}
    </div>
  );
};

export default CardEmpty;
